import * as React from 'react'
import { useHistory } from 'react-router-dom'

import { AllyUserRole, AutoToBankLinkingScreen } from '@ally/transmitigator'
import { Button, Space, TextBody } from '@ally/metronome-ui'
import { LoginHeading } from '@ally/ally-login'

import { LoggedInAlert, StyledTextBody } from '../Shared'
import { useTransmit } from '../../TransmitContext'
import { getDisplayRole } from '../../Utils'
import { useHostServices } from '../../HostServices'

export const rolesToLinkRelationships = (roles: AllyUserRole): string => {
  const linkRelationships = []
  const { bank, creditcard, investment, mortgage } = roles

  if (bank) linkRelationships.push('bank')
  if (investment) linkRelationships.push('invest')
  if (creditcard) linkRelationships.push('credit card')
  if (mortgage) linkRelationships.push('home loans')

  return linkRelationships.join(',')
}

const AutoToBankLinkingContent: React.FC<Pick<
  AutoToBankLinkingScreen['payload'],
  'status' | 'username' | 'userSoftLinkedRelationships'
>> = ({ status, username, userSoftLinkedRelationships }) => {
  const history = useHistory()
  const { analytics } = useHostServices()

  const handleOnClick = (): void => {
    history.push(
      `/?linkRelationships=${rolesToLinkRelationships(
        userSoftLinkedRelationships,
      )}`,
    )
  }

  React.useEffect(() => {
    analytics.trackPageView({
      eventType: 'pageview',
      pageName: 'AOS:Login:Link Bank Account',
    })
  }, [])

  return (
    <>
      <LoggedInAlert displayRole="Auto" username={username} />

      <LoginHeading title="Let's link up." />

      <Space mb="lg">
        <StyledTextBody size="sm" tag="p">
          Linking lets you manage all of your info in one spot, with one set of
          credentials. More to see, with less to remember.
        </StyledTextBody>
      </Space>

      <Space mb="md">
        <StyledTextBody size="sm" tag="p">
          To link your accounts and continue to Snapshot, you&apos;ll need to
          log in with your{' '}
          <TextBody size="sm" tag="b" weight="bold">
            {getDisplayRole(userSoftLinkedRelationships)}
          </TextBody>{' '}
          username, then confirm your Auto info one more time.
        </StyledTextBody>
      </Space>

      <Button
        allytmln="Continue"
        loading={status === 'Loading'}
        onClick={handleOnClick}
        text="Continue"
        type="submit"
        variant="primary"
      />
    </>
  )
}

export const AutoToBankLinking: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'AutoToBankLinking') {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <AutoToBankLinkingContent {...activeScreen.payload} />
}
